import { dayStrOrDateToDayString, PagingMetadata } from '@shared/pagingHelpers'
import { PortfolioCTO } from '@shared/PortfolioCTO'
import { EthAddr } from '@shared/SchemaTypes'
import axios from 'axios'
import { Dayjs } from 'dayjs'
import { ethers } from 'ethers'

// // Copyright Open Trade Technology Ltd. 2023. All rights reserved.
export const portfolioFetcherDaily = async (
  serverApiBaseUrl: string,
  restAPIKey: string,
  accountAddr: EthAddr | undefined,
  liquidityTokenSymbol: 'USDC' | 'EURC' | 'MUSDC',
  startDayStrOrDate: string | Date | Dayjs,
  endDayStrOrDate: string | Date | Dayjs,
  page?: number,
  pageSize?: number,
  poolAddr?: EthAddr
): Promise<{ portfolioCTOs: PortfolioCTO[]; pagingMetadata: PagingMetadata }> => {
  const startDayStr = dayStrOrDateToDayString(startDayStrOrDate)
  const endDayStr = dayStrOrDateToDayString(endDayStrOrDate)

  let url: string
  if (accountAddr) {
    const accountAddrNormalized = ethers.getAddress(accountAddr)
    url = `${serverApiBaseUrl}/dailyPortfolios/${accountAddrNormalized}?startDayStr=${startDayStr}&endDayStr=${endDayStr}&page=${page ?? 0}&pageSize=${pageSize ?? 10}&liquidityTokenSymbol=${liquidityTokenSymbol}`
  } else {
    const poolAddrParam = poolAddr ? `&poolAddress=${poolAddr}` : ''
    url = `${serverApiBaseUrl}/dailyPortfolios?startDayStr=${startDayStr}&endDayStr=${endDayStr}&page=${page ?? 0}&pageSize=${pageSize ?? 10}&liquidityTokenSymbol=${liquidityTokenSymbol}${poolAddrParam}`
  }

  const response = await axios(url, {
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': restAPIKey,
    },
  })
  return response.data
}
